module.exports = __webpack_public_path__ + "img/available-on-playstore.ef2f22a2.png";